{
	"ariaSetPhotoColorTag": "Set Photo Color Tag"
}
